// 客户管理
export default [{ // 客户信息
  path: '/customerInformation',
  name: 'customerInformation',
  component: resolve => require(['@/views/customer/customerInformation/customerInformation.vue'], resolve),
  meta: {
    group: "/customerInformation",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 新增客户信息
  path: '/addCustomer',
  name: 'addCustomer',
  component: resolve => require(['@/views/customer/customerInformation/addCustomer.vue'], resolve),
  meta: {
    group: "/customerInformation",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 编辑客户信息
  path: '/editCustomer',
  name: 'editCustomer',
  component: resolve => require(['@/views/customer/customerInformation/addCustomer.vue'], resolve),
  meta: {
    group: "/customerInformation",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 查看客户信息
  path: '/viewCustomer',
  name: 'viewCustomer',
  component: resolve => require(['@/views/customer/customerInformation/addCustomer.vue'], resolve),
  meta: {
    group: "/customerInformation",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/customer/customer.js